/** Türkçe arayüz metinleri — durum kodları API'de İngilizce kalır */
export const statusLabel = (status) => STATUS_TR[status] || status;

export const STATUS_TR = {
  Success: 'Başarılı',
  Failed: 'Başarısız',
  'Appointment Created': 'Randevu oluşturuldu',
  'Info Provided': 'Bilgi verildi',
  'Appointment Requested': 'Randevu tamamlanamadı',
  Transferred: 'Aktarıldı',
  'Routed to Patient Relations': 'Hasta ilişkileri yönlendirme',
  'Routed to Billing': 'Muhasebe yönlendirme',
  'Emergency Redirect': 'Acil yönlendirme',
  'Routed to MTS/SKS': 'Hasta ilişkileri yönlendirme',
};

export const STATUS_FILTER_OPTIONS = [
  { value: 'all', label: 'Tüm durumlar' },
  { value: 'Appointment Created', label: statusLabel('Appointment Created') },
  { value: 'Appointment Requested', label: statusLabel('Appointment Requested') },
  { value: 'Routed to Patient Relations', label: statusLabel('Routed to Patient Relations') },
  { value: 'Routed to Billing', label: statusLabel('Routed to Billing') },
  { value: 'Emergency Redirect', label: statusLabel('Emergency Redirect') },
  { value: 'Transferred', label: statusLabel('Transferred') },
  { value: 'Info Provided', label: statusLabel('Info Provided') },
  { value: 'Failed', label: statusLabel('Failed') },
  { value: 'Success', label: `${statusLabel('Success')} (eski)` },
];

export const SCRIPT_LABEL_TR = {
  chiefComplaintQuestion: 'Şikayet sorusu',
  confirmationTemplate: 'Onay cümlesi şablonu',
  prepNote: 'Hazırlık notu',
  emergencyNote: 'Acil durum notu',
  reminderClosing: 'Kapanış hatırlatma metni',
  transferHoldInstruction: 'Aktarım bekleme talimatı',
  postBookClosing: 'Randevu sonrası kapanış',
  noDiagnosisNote: 'Teşhis verilmez notu',
  kvkkNotice: 'KVKK bilgilendirme',
};

export const CHANNEL_TR = {
  web_panel: 'Web paneli',
  phone: 'Telefon',
  voice: 'Telefon',
  social: 'Sosyal medya',
  facebook: 'Facebook',
  instagram: 'Instagram',
  tiktok: 'TikTok',
  whatsapp: 'WhatsApp',
};
